import { Schema } from '@togglecorp/ravl';

const userSchema: Schema[] = [];

{
    const schema = {
        doc: {
            name: 'user',
            description: 'Data for user',
        },
        fields: {
            id: { type: 'uint', required: true },
            username: { type: 'string', required: true },
            email: { type: 'email', required: false },
            name: { type: 'string', required: true },
            firstName: { type: 'string', required: true },
            lastName: { type: 'string', required: true },
            todayLog: { type: 'dailyLog', required: false },
            supervisors: { type: 'array.miniUser', required: true },
            allUsers: { type: 'array.miniUser', required: true },
            isSupervisor: { type: 'boolean', required: true },
            address: { type: 'string' },
            position: { type: 'string' },
            contractStartDate: { type: 'string' }, // date
            contractEndDate: { type: 'string' }, // date
            dateOfBirth: { type: 'string' }, // date
            // NOTE: need to remove projects from user
            projects: { type: 'array.projectMini', required: false },
        },
    };
    userSchema.push(schema);
}

{
    const schema = {
        doc: {
            name: 'miniUser',
            description: 'Mini data for user',
        },
        fields: {
            id: { type: 'uint', required: true },
            name: { type: 'string', required: true },
            address: { type: 'string' },
            position: { type: 'string' },
        },
    };
    userSchema.push(schema);
}
{
    const schema = {
        doc: {
            name: 'users',
            description: 'User List Response',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.user', required: true },
        },
    };
    userSchema.push(schema);
}
{
    const schema = {
        doc: {
            name: 'supervisors',
            description: 'Supervisor List Response',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.miniUser', required: true },
        },
    };
    userSchema.push(schema);
}

{
    const schema = {
        doc: {
            name: 'projectForOptions',
            description: 'project',
        },
        fields: {
            id: { type: 'uint', required: true },
            title: { type: 'string', required: true },
        },
    };
    userSchema.push(schema);
}

{
    const schema = {
        doc: {
            name: 'superviseOptions',
            description: 'Options for filters',
        },
        fields: {
            users: { type: 'array.miniUser', required: true },
            projects: { type: 'array.projectForOptions', required: true },
            leaveTypes: { type: 'array.leaveType', required: true },
        },
    };
    userSchema.push(schema);
}

export default userSchema;
